// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import Copy from './logic'

export default function CopyFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/Copy">
      <Copy {...props}>
        {children}
      </Copy>
    </Flow>
  )
}
